import { css } from '@/styled-system/css';

export const sliderActiveTrackStyles = css.raw({
  position: 'absolute',
  width: '100%',
  height: 'Slider.Track.height',
  borderRadius: 'shape.capsule',
  pointerEvents: 'none',
  backgroundColor: 'bg.action.hero.selected.default',
});
